export default {"src":"/_next/static/media/Arrow-up-white.e21097c9.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};